import cashierService from 'modules/POS/services';
import { useEffect } from 'react';
import { Message } from 'stompjs';
import { PaymentSocketData, TypePaymentActors, TypePaymentPassData } from '../socket.interface';

const useListenRequestSync = (syncDetailData: (billId: string) => void) => {
  const cashierMsg = cashierService.selectors.cashierMsg();
  const listeningData = (message: Message) => {
    if (!message.body) return;
    const payment: PaymentSocketData = JSON.parse(message.body);
    if (!payment) return;
    if (payment.actor !== TypePaymentActors.CUSTOMER) return;

    switch (payment.action) {
      case TypePaymentPassData.REQUEST_SYNC_DETAIL: {
        syncDetailData(payment.data.billId);
        break;
      }
      default:
        break;
    }
  };
  useEffect(() => {
    if (!cashierMsg) return;
    listeningData(cashierMsg);
  }, [cashierMsg]);
};

export default useListenRequestSync;
